import * as React from 'react';
import { DataGrid } from '@material-ui/data-grid';

function InsiderTransactionsDataGrid({data} :any) {

  function tableRowClass(decisionColor) {
    if (decisionColor == 'Dispose') {
      return 'table-danger'
    } else {
      return 'table-success'
    }
  }

  const columns = [
    { field: 'id', hide: true},
    { field: 'date', headerName: 'Date', width: 100, renderHeader:(params) => ( <strong>Date</strong>)},
    { field: 'owner', headerName: 'Owner', width: 180, renderHeader:(params) => ( <strong>Owner</strong>)},
    { field: 'title', headerName: 'Title', width: 210, renderHeader:(params) => ( <strong>Title</strong>)},
    { field: 'type', headerName: 'Type',  width: 80, renderHeader:(params) => ( <strong>Type</strong>)},
    { field: 'transaction', headerName: 'Transaction', width: 200, renderHeader:(params) => ( <strong>Transaction</strong>)},
    { field: 'shares', headerName: 'Shares', width: 150, renderHeader:(params) => ( <strong>Shares</strong>)},
    { field: 'value', headerName: 'Value', width: 150, renderHeader:(params) => ( <strong>Value</strong>)},
    { field: 'price', headerName: 'Price', width: 100, renderHeader:(params) => ( <strong>Price</strong>)},
    { field: 'remaining', headerName: 'Remaining', width: 100, renderHeader:(params) => ( <strong>Remaining</strong>)}
  ]

  function buildCompanyData(item) {
    return {
      id: item.id,
      date: item.transaction_date,
      owner: item.owner,
      title: item.title,
      type: item.transaction_type,
      transaction: item.security_name,
      shares: item.shares,
      value: item.transaction_value,
      price: item.price,
      remaining: item.shares_owned
    }
  }

  const rows = data?.map(item => buildCompanyData(item));

  return (
    <div className="row">
      <style>{`
        .insider-transactions-grid {
          width: 100%;
        }

        .insider-transactions-grid .MuiDataGrid-root {
          border: 1px solid #e5e7eb;
          background: #ffffff;
        }

        .insider-transactions-grid .MuiDataGrid-columnHeaders {
          background: #f9fafb;
          border-bottom: 1px solid #e5e7eb;
        }

        .insider-transactions-grid .MuiDataGrid-columnHeader,
        .insider-transactions-grid .MuiDataGrid-cell {
          border-bottom: 1px solid #f3f4f6;
        }

        .insider-transactions-grid .MuiDataGrid-cell {
          color: #111827;
        }

        .insider-transactions-grid .MuiDataGrid-cell:focus,
        .insider-transactions-grid .MuiDataGrid-columnHeader:focus,
        .insider-transactions-grid .MuiDataGrid-cell:focus-within,
        .insider-transactions-grid .MuiDataGrid-columnHeader:focus-within {
          outline: none;
        }

        .insider-transactions-grid .MuiDataGrid-row:hover {
          background: #f9fafb;
        }

        .insider-transactions-grid .MuiDataGrid-footerContainer {
          border-top: 1px solid #e5e7eb;
          background: #ffffff;
        }

        .insider-transactions-grid .MuiTablePagination-root,
        .insider-transactions-grid .MuiTablePagination-caption,
        .insider-transactions-grid .MuiTablePagination-selectIcon,
        .insider-transactions-grid .MuiIconButton-root {
          color: #4b5563;
        }

        .dark-mode .insider-transactions-grid .MuiDataGrid-root {
          border-color: #322f2f;
          background: #222328;
          color: #ffffff;
        }

        .dark-mode .insider-transactions-grid .MuiDataGrid-columnHeaders {
          background: linear-gradient(to right, #1a191d, #222328);
          border-bottom-color: #322f2f;
        }

        .dark-mode .insider-transactions-grid .MuiDataGrid-columnHeader,
        .dark-mode .insider-transactions-grid .MuiDataGrid-cell {
          border-bottom-color: #322f2f;
        }

        .dark-mode .insider-transactions-grid .MuiDataGrid-cell {
          color: #ffffff;
        }

        .dark-mode .insider-transactions-grid .MuiDataGrid-row:hover {
          background: rgba(255, 255, 255, 0.03);
        }

        .dark-mode .insider-transactions-grid .MuiDataGrid-row.table-danger {
          background: rgba(254, 124, 150, 0.12);
        }

        .dark-mode .insider-transactions-grid .MuiDataGrid-row.table-success {
          background: rgba(27, 207, 180, 0.12);
        }

        .dark-mode .insider-transactions-grid .MuiDataGrid-row.table-danger:hover {
          background: rgba(254, 124, 150, 0.18);
        }

        .dark-mode .insider-transactions-grid .MuiDataGrid-row.table-success:hover {
          background: rgba(27, 207, 180, 0.18);
        }

        .dark-mode .insider-transactions-grid .MuiDataGrid-footerContainer {
          border-top-color: #322f2f;
          background: #1a191d;
        }

        .dark-mode .insider-transactions-grid .MuiTablePagination-root,
        .dark-mode .insider-transactions-grid .MuiTablePagination-caption,
        .dark-mode .insider-transactions-grid .MuiTablePagination-selectIcon,
        .dark-mode .insider-transactions-grid .MuiIconButton-root,
        .dark-mode .insider-transactions-grid .MuiDataGrid-columnSeparator {
          color: #d8d8d8;
        }
      `}</style>
      <div className="insider-transactions-grid">
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10]}
          autoHeight={true}
          autoPageSize={true}
          density={"compact"}
          disableColumnMenu
          getRowClassName={(params) =>
            (tableRowClass(params.getValue(params.id, 'type')))
          }
        />
      </div>
    </div>
  );
}

export default InsiderTransactionsDataGrid;
